class exports.Layer_Shapefile_Binning extends DialogHandler
    init: () ->
        @layoutUrl      = 'backend/grower/layers/shapefile/load-layout'
        @saveUrl        = 'backend/grower/layers/shapefile/set-binning'
        @destroyOnSave  = false
        @slideUpForm    = false
        @refreshNavHandler = false
        @createDialog()


    afterLoadLayout: () ->
        @saveData.id = @loadLayoutPostOptions.id
        @submitAction   = () ->
            @save('Saving...')

        @successAction  = () =>
            nickname = "shapefile" + @loadLayoutPostOptions.layer_id
            layer = @parent.activeSubHandlers[nickname]

            if layer
                layer.binning = @dialog.find('.binning_attr').val()
                layer.refresh()

        @openDialog()

